var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvitesIcon = function SvgInvitesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.126,
    height: 17.594,
    x: 6,
    y: 9,
    stroke: "#373737",
    strokeWidth: 2,
    rx: 1.449
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#373737",
    strokeWidth: 1.5,
    d: "m6.633 9.633 9.305 7.975a3.266 3.266 0 0 0 4.25 0l9.305-7.975"
  })));
};
export default SvgInvitesIcon;